import { Controller } from "@hotwired/stimulus"

/**
 * Payment Plan Interest Controller
 *
 * Dynamically updates the interest summary box based on selected payment plan option.
 * Shows total balance, and interest added for the selected plan.
 */
export default class extends Controller {
  static targets = ["totalBalance", "interestAdded"]

  static values = {
    plans: Object,
  }

  connect() {
    this.setupRadioButtonListeners()
  }

  setupRadioButtonListeners() {
    const radioButtons = this.element.querySelectorAll('input[name*="payments_count"]')

    radioButtons.forEach((radio) => {
      radio.addEventListener("change", () => {
        if (radio.checked) {
          this.updateInterestDisplay(radio)
        }
      })
    })
  }

  updateInterestDisplay(radio) {
    const selectedPaymentsCount = parseInt(radio.value, 10)
    const planData = this.plansValue[selectedPaymentsCount]

    this.updateInterestValues(planData)
  }

  updateInterestValues(planData) {
    this.totalBalanceTarget.textContent = planData.total_balance_with_interest
    this.interestAddedTarget.textContent = planData.total_interest
  }
}
